import React, { useState, useEffect, useRef } from "react";

import {
  Button,
  Dialog,
  Grid,
  Icon,
  Paper,
  RadioGroup,
  Typography,
  Container,
  Divider,
  TextField,
  FormLabel,
  FormHelperText,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  Select,
} from "@material-ui/core";

import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import {
  Label,
  DraggableComponent,
} from "../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../Services/APIService";
import { withSnackbar } from "../../../../../components/Message/Alert";
import useStyles from "./styles";
import {
    validateEmail, validatePhoneNumber, allowedAttachmentsImages, handleNumberKeyPress, getFormatedDate, formatDateTime, formatDate,
    getLocalDateFromUTC,
} from "../../../../../../src/components/Common/Extensions";
import PreviewPhoto from "../../../../../assets/img/previewImg.png";
import Logo from "../../../../../assets/img/SheilaFiggLogo.png";

import axios from "axios";
import DialogLoader from "../../../../../components/Loader/DialogLoader";
import PressReleaseHeader from "../../../../../assets/img/common/pressRelease.png";
import PressReleaseFooter from "../../../../../assets/img/common/pressReleaseFooter.png";
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/Email';
import LanguageIcon from '@material-ui/icons/Language';
import LocationOnIcon from '@material-ui/icons/LocationOn';

function Preview({dialogOpenClose,handleClose,handleSuccessClose , record,...props}) {
  const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const getCurrentFormattedDate = (_date) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Date(_date).toLocaleDateString(undefined, options);
        return formattedDate;
    };
    const getPressReleaseRecord = () => {
        setIsLoading(true);
        PostDataAPI("fdnemployeepressrelease/get",record.pressReleaseId).then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data);
                setState(result.data);
            }
            else {
            }
            setIsLoading(false);

        })
    }
  useEffect(() => {
      getPressReleaseRecord();
  }, []);

  return (
      <Dialog
          classes={{ paper: classes.dialogPaper }}
          disableBackdropClick
          disableEscapeKeyDown
          open={dialogOpenClose}
          PaperComponent={DraggableComponent}
          maxWidth="md"
          {...props}
      >
          <div className={classes.dialogContent}>
              <div className={classes.box}>
                  <div className={classes.header} id="draggable-dialog-title">
                      <Typography className={classes.title}>Preview</Typography>

                      <Icon
                          className={classes.closeIcon}
                          onClick={handleClose}
                          color="primary"
                      >
                          <CloseIcon />
                      </Icon>
                  </div>

                  {isLoading ? <DialogLoader></DialogLoader> : ""}
                  <Scrollbars autoHeight autoHeightMax={440}>
                      <div className={classes.content}>
                          <Grid item sm={12} md={12} lg={12}  xl={12}
                          >
                              <div className={classes.templateContainer}>
                                  <div>
                                      <img width="100%" src={PressReleaseHeader} />
                                  </div>

                                  <Grid container alignItems="center">
                                      <Grid item lg={6} md={6}></Grid>
                                      <Grid item lg={6} md={6} className={"textRight"}>
                                          <h4>{getCurrentFormattedDate(state.createDate)}</h4>
                                      </Grid>
                                  </Grid>

                                  <div className={"contentPadding"}>
                                      <h1 className="textCenter">{state.title}</h1>

                                      <Grid container>
                                          <Grid item md={12} lg={12}>
                                              <p
                                                  dangerouslySetInnerHTML={{
                                                      __html: state.content,
                                                  }}
                                              ></p>
                                          </Grid>
                                      </Grid>


                                  </div>


                                  <div className={"contentPadding"}>
                                      {state?.lstLinks?.length > 0 ? (
                                          <div>
                                              <b>Reference Link</b>
                                          </div>
                                      ) : null}
                                  </div>

                                  <div className={"contentPadding"}>
                                      {state?.lstLinks ? (
                                          <ul className={classes.refLinksShow}>
                                              {state?.lstLinks.map((item, i) => (
                                                  <li key={i}>
                                                      <a href={item.url} target="_blank">
                                                          {item.url}
                                                      </a>
                                                  </li>
                                              ))}
                                          </ul>
                                      ) : null}
                                  </div>


                                  <div className={"contentPadding"}>
                                      <p className={classes.FooterText}>
                                          The Figgers Foundation is a not-for-profit 501 (c) 3 foundation registered with the IRS and the Florida Department of Agriculture, Chapter s. 496.405, Florida Statutes for the purpose of solicitation of contributions.
                                      </p>
                                  </div>
                                  <div>
                                      <img width={"100%"} src={PressReleaseFooter} />
                                  </div>


                                  <Grid container>
                                      <Grid
                                          lg={12}
                                          md={12}
                                          sm={12}
                                      // className={classes.footerGrid}
                                      >

                                          <Grid container className={classes.templateSocial}>
                                              <Grid item sm={4} lg={4} md={4}>
                                                  <o> <CallIcon /> 1-800-391-2803</o>
                                              </Grid>

                                              <Grid item sm={4} lg={4} md={4}>
                                                  <o> <EmailIcon /> Info@FiggersFoundation.org</o>
                                              </Grid>

                                              <Grid item sm={4} lg={4} md={4} style={{ textAlign: 'right' }}>
                                                  <o> <LanguageIcon /> FiggersFoundation.org</o>
                                              </Grid>

                                          </Grid>


                                          <div className={classes.templateFooter}>


                                              <Grid container>
                                                  <Grid item lg={12} md={12} sm={12}>
                                                      <p> <LocationOnIcon style={{ fontSize: '18px', margin: '0 5px' }} /> 3810 Inverrary Boulevard, Suite 401 Fort Lauderdale, Florida 33319</p>
                                                  </Grid>

                                              </Grid>
                                          </div>
                                      </Grid>
                                  </Grid>
                              </div>
                          </Grid>
                      </div>
                  </Scrollbars>
              </div>
          </div>
      </Dialog>
  );
}

export default withSnackbar(Preview);
